{
  "Accessibility Menu": "Barrierefreiheit",
  "Reset settings": "Einstellungen zurücksetzen",
  "Close": "Schließen",
  "Content Adjustments": "Inhaltsanpassungen",
  "Adjust Font Size": "Schriftgröße anpassen",
  "Highlight Title": "Titel hervorheben",
  "Highlight Links": "Links hervorheben",
  "Readable Font": "Lesbare Schrift",
  "Color Adjustments": "Farbanpassungen",
  "Dark Contrast": "Dunkler Kontrast",
  "Light Contrast": "Heller Kontrast",
  "High Contrast": "Hoher Kontrast",
  "High Saturation": "Hohe Farbsättigung",
  "Low Saturation": "Niedrige Farbsättigung",
  "Monochrome": "Monochrom",
  "Contrast": "Kontrast",
  "Invert Colors": "Farben invertieren",
  "Tools": "Werkzeuge",
  "Reading Guide": "Lesehilfe",
  "Stop Animations": "Animationen stoppen",
  "Big Cursor": "Großer Cursor",
  "Increase Font Size": "Schriftgröße vergrößern",
  "Decrease Font Size": "Schriftgröße verkleinern",
  "Letter Spacing": "Zeichenabstand",
  "Line Height": "Zeilenhöhe",
  "Font Weight": "Schriftstärke",
  "Dyslexia Font": "Dyslexie-Schrift",
  "Language": "Sprache",
  "Open Accessibility Menu": "Barrierefreiheitsmenü öffnen",
  "Widget Settings": "Widget-Einstellungen",
  "Widget Position": "Widget-Position",
  "Top Left": "Oben links",
  "Top Center": "Oben mittig",
  "Top Right": "Oben rechts",
  "Center Left": "Mittig links",
  "Center Right": "Mittig rechts",
  "Bottom Left": "Unten links",
  "Bottom Center": "Unten mittig",
  "Bottom Right": "Unten rechts",
  "Screen Reader": "Bildschirmleser",
  "Voice Navigation": "Sprachsteuerung",
  "Custom Color": "Benutzerdefinierte Farbe",
  "Change the site's colors": "Farben der Website ändern",
  "Backgrounds": "Hintergründe",
  "Headings": "Überschriften",
  "Contents": "Inhalte",
  "Reset colors": "Farben zurücksetzen",
  "Image Desaturation": "Bild entsättigen",
  "Search languages": "Sprachen suchen",
  "No languages found": "Keine Sprachen gefunden",
  "Accessibility Profiles": "Barrierefreiheits-Profile",
  "Motor Impaired": "Motorische Einschränkung",
  "Big cursor, voice navigation, and no animations.": "Großer Cursor, Sprachsteuerung und keine Animationen.",
  "Blind": "Blind",
  "Screen reader helpers with higher contrast.": "Screenreader-Hilfen mit höherem Kontrast.",
  "Color Blind": "Farbenblind",
  "High contrast palette with desaturated media.": "Paletten mit hohem Kontrast und entsättigten Medien.",
  "Dyslexia": "Legasthenie",
  "Friendly font, extra spacing, stronger weight.": "Gut lesbare Schrift, mehr Abstand und stärkere Strichstärke.",
  "Low vision": "Sehschwach",
  "Dark contrast and 130% magnification.": "Dunkler Kontrast und 130 % Vergrößerung.",
  "Cognitive & Learning": "Kognitiv & Lernen",
  "Highlights key sections and enables voice help.": "Hebt Schlüsselsektionen hervor und aktiviert Sprachhilfe.",
  "Seizure & Epileptic": "Anfälle & Epilepsie",
  "Stops animations and desaturates imagery.": "Stoppt Animationen und entsättigt Bilder.",
  "ADHD": "ADHS",
  "Reading guide, highlighted links, calmer palette.": "Leseführung, hervorgehobene Links und ruhigere Palette.",
  "Widget Size": "Widget-Größe",
  "Default": "Standard",
  "Medium": "Mittel",
  "Small": "Klein",
  "Color Blindness": "Farbenblindheit",
  "Protanopia": "Protanopie",
  "Deuteranopia": "Deuteranopie",
  "Tritanopia": "Tritanopie",
  "Achromatopsia": "Achromatopsie",
  "Simulates and assists users with color vision deficiencies.": "Simuliert und unterstützt Benutzer mit Farbfehlsichtigkeiten."
}
